export default function mapAllById(list, mappedList) {
  return list.map(function (id) {
    return mappedList[id];
  });
}